import { toast } from 'react-toastify';

const defaultConfig = {
  position: "top-center",
  rtl: true,
  autoClose: 5000,
  hideProgressBar: true,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: false,
  closeButton: false,
  theme: "light",
  style: {
    fontFamily: "var(--font-ibm-plex-sans-arabic)",
    fontSize: "14px",
    textAlign: "right",
    minWidth: "300px",
    padding: "12px 15px",
    borderRight: "4px solid",
    boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
  }
};

export const toastService = {
  success: (message) => {
    toast.success(message, {
      ...defaultConfig,
      style: {
        ...defaultConfig.style,
        background: "#DCFCE7",
        color: "#166534",
        borderRightColor: "#22C55E"
      }
    });
  },

  error: (message) => {
    toast.error(message, {
      ...defaultConfig,
      isLoading: false,
      style: {
        ...defaultConfig.style,
        background: "#FEE2E2",
        color: "#991B1B",
        borderRightColor: "#EF4444",
        textAlign: "center",
        whiteSpace: "pre-line"
      }
    });
  },

  warning: (message) => {
    toast.warning(message, {
      ...defaultConfig,
      style: {
        ...defaultConfig.style,
        background: "#FEF3C7",
        color: "#92400E",
        borderRightColor: "#F59E0B"
      }
    });
  },

  info: (message) => {
    toast.info(message, {
      ...defaultConfig,
      style: {
        ...defaultConfig.style,
        background: "#DBEAFE",
        color: "#1E40AF",
        borderRightColor: "#3B82F6"
      }
    });
  },

  loading: (message) => {
    return toast.loading(message, {
      ...defaultConfig,
      style: {
        ...defaultConfig.style,
        background: "#F3F4F6",
        color: "#1F2937",
        borderRightColor: "#6B7280"
      }
    });
  },

  // لتحديث toast موجود
  update: (toastId, message, type) => {
    toast.update(toastId, {
      render: message,
      type: type,
      ...defaultConfig,
      isLoading: false,
    });
  },

  // لإغلاق toast محدد
  dismiss: (toastId) => {
    toast.dismiss(toastId);
  },
};

export default toastService;
